<script lang="ts">
  import type { Snippet } from 'svelte';
  import AppBar from './AppBar.svelte';
  let {
    title,
    sync,
    children,
  }: { title: string; sync?: 'idle' | 'syncing' | 'error'; children: Snippet } = $props();
</script>

<div class="screen">
  <AppBar {title} {sync} />
  <main class="body">
    {@render children()}
  </main>
</div>

<style>
  .screen {
    display: flex;
    flex-direction: column;
    min-height: 100dvh;
    padding-bottom: calc(var(--tabbar-h) + env(safe-area-inset-bottom));
  }
  @media (min-width: 900px) {
    .screen {
      padding-left: 84px;
      padding-bottom: 0;
    }
  }
  .body {
    flex: 1;
    width: 100%;
    max-width: var(--content-max);
    margin: 0 auto;
    padding: 20px 18px 32px;
  }
</style>
